import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=2e167b90&scoped=true&"
var script = {}
import style0 from "./icons.vue?vue&type=style&index=0&id=2e167b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e167b90",
  null
  
)

export default component.exports